<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit FAQ Section</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/faqsections" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateFAQsection" v-if="faqsection">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="faqsection.faqHeader"
                                  label="Section Header"
                                  placeholder="Enter Section Header"
                                  v-validate="rules.faqHeader"
                                  data-vv-name="Message"
                                  cus-name="Message"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="faqsection.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update FAQ Section
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditGreeting',
        created (){
        this.$store.dispatch('GETSELECTEDFAQSECTION', this.$route.params.id).then(() =>{
            this.faqsection = this.selectedFaqsection;
        })
    },
    data () {
        let dateTime = new Date();
        return {
            faqsection: this.selectedFaqsection || {},
          rules: {
            faqHeader: {required : true},
            active: {required: true}
          },
          message: {
            error: false,
            text: ''
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
        }
    },
    methods: {
      updateFAQsection () {
          this.$validator.validateAll().then((result) => {
            if(result){

              let updateFaqsection = () =>{
                this.$store.dispatch('UPDATE_FAQSECTION', this.faqsection)
                  .then((res) => {
                    console.log("UPDATE_EVENT res : ", res);
                    this.showPopup('Success!', 'FAQ Section is successfully updated', 'success', ()=>this.$router.push('/admin/faqsections'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_Greeting API error : ", err);
                  })
              };
              updateFaqsection();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
         'selectedFaqsection']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/FAQSect/EditFAQSection.vue